// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3x93s","validationTips":"StatementDescriptor_validationTips__9PVvU"};